// File: src/components/Footer.js - Angepasst für Ant Design
import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Row, Col, Typography, Divider, Space } from 'antd'; // Antd Komponenten importieren
import { FacebookOutlined, InstagramOutlined, TwitterOutlined } from '@ant-design/icons'; // Icons importieren
// Entferne den Import für Footer.css, da Ant Design das Styling übernimmt
// import './Footer.css';

const { Footer: AntFooter } = Layout;
const { Title, Paragraph, Text } = Typography;

// Liste der Bundesländer für die Links
const bundeslaender = [
    { name: 'Baden-Württemberg', slug: 'baden-wuerttemberg' },
    { name: 'Bayern', slug: 'bayern' },
    { name: 'Berlin', slug: 'berlin' },
    { name: 'Brandenburg', slug: 'brandenburg' },
    { name: 'Bremen', slug: 'bremen' },
    { name: 'Hamburg', slug: 'hamburg' },
    { name: 'Hessen', slug: 'hessen' },
    { name: 'Mecklenburg-Vorpommern', slug: 'mecklenburg-vorpommern' },
    { name: 'Niedersachsen', slug: 'niedersachsen' },
    { name: 'Nordrhein-Westfalen', slug: 'nordrhein-westfalen' },
    { name: 'Rheinland-Pfalz', slug: 'rheinland-pfalz' },
    { name: 'Saarland', slug: 'saarland' },
    { name: 'Sachsen', slug: 'sachsen' },
    { name: 'Sachsen-Anhalt', slug: 'sachsen-anhalt' },
    { name: 'Schleswig-Holstein', slug: 'schleswig-holstein' },
    { name: 'Thüringen', slug: 'thueringen' },
];

const Footer = () => {
    const currentYear = new Date().getFullYear();

    // Inline-Styles für dunklen Footer (könnte auch über Antd Theme angepasst werden)
    const footerStyle = {
        backgroundColor: '#222',
        color: 'rgba(255, 255, 255, 0.65)',
        padding: '40px 0',
    };

    const linkStyle = {
        color: 'rgba(255, 255, 255, 0.65)',
    };

    const linkHoverStyle = {
        color: '#fff',
    };

    const titleStyle = {
        color: '#fff',
        marginBottom: '20px',
    };

    const iconStyle = {
        fontSize: '20px',
        color: 'rgba(255, 255, 255, 0.65)',
        transition: 'color 0.3s'
    };

    const iconHoverStyle = {
        color: '#fff' // oder var(--primary-color)
    };

    return (
        <AntFooter style={footerStyle}>
            <div style={{ maxWidth: 'var(--container-width, 1200px)', margin: '0 auto', padding: '0 20px' }}>
                <Row gutter={[48, 32]}> {/* Gutter: horizontal, vertical */}
                    {/* Spalte 1: Beschreibung & Social Media (Breite angepasst) */}
                    <Col xs={24} sm={24} md={8} lg={6}>
                        <Title level={4} style={titleStyle}>Snus Finder</Title>
                        <Paragraph style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                            Das größte Verzeichnis für Snus-Verkaufsstellen in Deutschland.
                            Finden Sie autorisierte Händler in Ihrer Nähe.
                        </Paragraph>
                        <Space size="middle">
                            <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                <FacebookOutlined style={iconStyle} onMouseOver={(e) => e.currentTarget.style.color = iconHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = iconStyle.color} />
                            </a>
                            <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                <InstagramOutlined style={iconStyle} onMouseOver={(e) => e.currentTarget.style.color = iconHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = iconStyle.color} />
                            </a>
                            <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                                <TwitterOutlined style={iconStyle} onMouseOver={(e) => e.currentTarget.style.color = iconHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = iconStyle.color} />
                            </a>
                        </Space>
                    </Col>

                    {/* Spalte 2: Schnellzugriff (Breite angepasst) */}
                    <Col xs={12} sm={12} md={4} lg={4}>
                        <Title level={5} style={titleStyle}>Schnellzugriff</Title>
                        <Space direction="vertical" size="small">
                            <Link to="/" style={linkStyle} onMouseOver={(e) => e.currentTarget.style.color = linkHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = linkStyle.color}>Startseite</Link>
                            <Link to="/shops" style={linkStyle} onMouseOver={(e) => e.currentTarget.style.color = linkHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = linkStyle.color}>Shops finden</Link>
                            <Link to="/about" style={linkStyle} onMouseOver={(e) => e.currentTarget.style.color = linkHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = linkStyle.color}>Über Snus</Link>
                            <Link to="/register" style={linkStyle} onMouseOver={(e) => e.currentTarget.style.color = linkHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = linkStyle.color}>Shop registrieren</Link>
                            <Link to="/contact" style={linkStyle} onMouseOver={(e) => e.currentTarget.style.color = linkHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = linkStyle.color}>Kontakt</Link>
                        </Space>
                    </Col>

                    {/* NEUE Spalte 3: Shops nach Bundesland */}
                    <Col xs={12} sm={12} md={4} lg={4}>
                        <Title level={5} style={titleStyle}>Nach Bundesland</Title>
                        <Space direction="vertical" size="small">
                            {bundeslaender.map(bl => (
                                <Link
                                    key={bl.slug}
                                    to={`/bl/${bl.slug}`}
                                    style={linkStyle}
                                    onMouseOver={(e) => e.currentTarget.style.color = linkHoverStyle.color}
                                    onMouseOut={(e) => e.currentTarget.style.color = linkStyle.color}
                                >
                                    {bl.name}
                                </Link>
                            ))}
                        </Space>
                    </Col>

                    {/* Spalte 4: Populäre Städte (Breite angepasst, xs/sm angepasst) */}
                    <Col xs={12} sm={12} md={4} lg={4}>
                        <Title level={5} style={titleStyle}>Populäre Städte</Title>
                        <Space direction="vertical" size="small">
                            <Link to="/shops?location=Berlin" style={linkStyle} onMouseOver={(e) => e.currentTarget.style.color = linkHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = linkStyle.color}>Snus in Berlin</Link>
                            <Link to="/shops?location=München" style={linkStyle} onMouseOver={(e) => e.currentTarget.style.color = linkHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = linkStyle.color}>Snus in München</Link>
                            <Link to="/shops?location=Hamburg" style={linkStyle} onMouseOver={(e) => e.currentTarget.style.color = linkHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = linkStyle.color}>Snus in Hamburg</Link>
                            <Link to="/shops?location=Köln" style={linkStyle} onMouseOver={(e) => e.currentTarget.style.color = linkHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = linkStyle.color}>Snus in Köln</Link>
                            <Link to="/shops?location=Frankfurt" style={linkStyle} onMouseOver={(e) => e.currentTarget.style.color = linkHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = linkStyle.color}>Snus in Frankfurt</Link>
                        </Space>
                    </Col>

                    {/* Spalte 5: Rechtliches (Breite angepasst, xs/sm angepasst) */}
                    <Col xs={12} sm={12} md={4} lg={6}>
                        <Title level={5} style={titleStyle}>Rechtliches</Title>
                        <Space direction="vertical" size="small">
                            <Link to="/privacy" style={linkStyle} onMouseOver={(e) => e.currentTarget.style.color = linkHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = linkStyle.color}>Datenschutz</Link>
                            <Link to="/agb" style={linkStyle} onMouseOver={(e) => e.currentTarget.style.color = linkHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = linkStyle.color}>AGB</Link>
                            <Link to="/impressum" style={linkStyle} onMouseOver={(e) => e.currentTarget.style.color = linkHoverStyle.color} onMouseOut={(e) => e.currentTarget.style.color = linkStyle.color}>Impressum</Link>
                        </Space>
                    </Col>
                </Row>

                <Divider style={{ borderColor: 'rgba(255, 255, 255, 0.2)', margin: '30px 0' }} />

                <Row justify="center" align="middle">
                    <Col style={{ textAlign: 'center' }}>
                        <Text style={{ color: 'rgba(255, 255, 255, 0.5)' }}>
                            &copy; {currentYear} Snus Verzeichnis Deutschland (Heinz Consulting). Alle Rechte vorbehalten.
                        </Text>
                        <br />
                        <Text style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '0.85em', marginTop: '5px', display: 'inline-block' }}>
                            Der Erwerb und Konsum von Snus ist nur für Personen ab 18 Jahren gestattet.
                        </Text>
                    </Col>
                </Row>
            </div>
        </AntFooter>
    );
};

export default Footer;